import React, { FC } from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider, useTheme } from "@mui/material";
import { createPortalTheme } from "../../theme/portalTheme";

/**
 * Wraps all patient portal routes with a nested theme (larger touch targets).
 */
const PortalLayout: FC = () => {
  const outerTheme = useTheme();
  const portalTheme = React.useMemo(
    () => createPortalTheme(outerTheme),
    [outerTheme],
  );

  return (
    <ThemeProvider theme={portalTheme}>
      <Outlet />
    </ThemeProvider>
  );
};

export default PortalLayout;
